import { Container, styled } from "@mui/material";

export const ContentWrapper = styled("div")(
    ({ theme }) => `
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`
);

export const ContainerStyles = styled(Container)(
    ({ theme }) => `
  flex-grow: 1;
  padding: 24px;
`
);

// @ts-ignore
export const AppBarSpacer = styled("div")(({ theme }) => ({
    ...theme.mixins.toolbar,
}));
